"use strict";
const { object, string, number } = require('../utils/modifiedYup');
exports.manualTriggerSchema = object().shape({
    id: number().required(),
    type: string().oneOf(['manual']).required(),
});
//# sourceMappingURL=manualTriggerSchema.js.map